module.exports = __webpack_public_path__ + "portal/assets/img/logo.4025b207.svg";